import React, { useState, useEffect } from "react";
import { Mentions, Icon, Button } from "antd";
import QuillEditor from "./TextEditor/QuillEditor";
import * as _ from "lodash";
import { Company } from "../../services/generated-sdk";
const { Option } = Mentions;

//const { toString } = Mention;

// const users = ["hitesh", "vishal", "shriti", "manu"];
// const tags = ["1.0", "2.0", "3.0"];

const MOCK_DATA = {
  "@": ["hitesh", "vishal", "shriti", "manu"],
  "#": ["1.0", "2.0", "3.0"],
  "{{": ["P-1", "P-2", "P-3"]
};

interface EditorProps {
  placeholder: string;
  onChange: (text: string) => void;
  setMentions?: (mentions: string[]) => void;
  value?: string;
  defaultValue?: string;
  rows?: number;
  projectUsers?: any[];
  company: Company;
  updateOnBlur?: boolean;
  hideToolbarOptions?: string[];
  testParameters?: string[];
}

export default function TCRichTextEditorv2(props: EditorProps): JSX.Element {
  //const [suggestions, setSuggestions] = useState <Array<string>> [];
  const [prefix, setPrefix] = React.useState("@");
  const [value, setValue] = React.useState("");

  useEffect(
    () => {
      setValue(props.value);
    },
    [props.value]
  );

  const onSearchChange = (value: string, trigger: string) => {
    setPrefix(trigger);
  };

  const onChange = value => {
    props.onChange(value);
  };

  const handleChange = value => {
    const update = _.trim(value) == "<p><br></p>" ? "" : value;
    setValue(update);
    if (props.onChange) {
      props.onChange(update);
    }
  };

  return (
    <QuillEditor
      placeholder={
        props.placeholder == "" ? "write here..." : props.placeholder
      }
      onChange={handleChange}
      setMentions={props.setMentions}
      value={value ? value : props.value ? props.value : undefined}
      supportEmoji={false}
      company={props.company}
      projectUsers={props.projectUsers || []}
      updateOnBlur={props.updateOnBlur ? props.updateOnBlur : false}
      hideToolbarOptions={
        props.hideToolbarOptions ? props.hideToolbarOptions : null
      }
      testParameters={props.testParameters ? props.testParameters : []}
    />
  );

  // console.log({ value: props.value });
  return (
    <div>
      <Mentions
        rows={props.rows ? props.rows : 3}
        style={{ width: "100%" }}
        placeholder={
          props.placeholder == "" ? "write here..." : props.placeholder
        }
        prefix={["@", "#"]}
        onSearch={onSearchChange}
        onChange={onChange}
        value={props.value ? props.value : ""}
      >
        {(MOCK_DATA[prefix] || []).map(value => (
          <Option key={value} value={value}>
            {value}
          </Option>
        ))}
      </Mentions>
      <div style={{ marginTop: -40, textAlign: "right" }} data-tabindex="-1">
        <Button type="link" data-tabindex="-1">
          <Icon type="paper-clip" style={{ fontSize: 20 }} />
        </Button>
        <Button type="link" data-tabindex="-1">
          <span style={{ fontSize: 20 }}>@</span>
        </Button>
        <Button type="link" data-tabindex="-1">
          <Icon style={{ fontSize: 20 }} type="smile" />
        </Button>
        <Button
          type="link"
          onClick={() => console.log("fff")}
          data-tabindex="-1"
        >
          <Icon style={{ fontSize: 20 }} type="tags" />
        </Button>
      </div>
    </div>
  );
}
